import { digObject, formatDate } from '@domain-group/javascript-utils'

import type { CampaignInspectionModel } from '@models/types'

type GroupedCampaignInspections = {
  [key: string]: {
    campaignInspections: CampaignInspectionModel[],
  },
}

export const groupInspectionsByDate = (campaignInspections: CampaignInspectionModel[]) => (
  campaignInspections.reduce((grouped, campaignInspection) => {
    const dateString = digObject(campaignInspection, 'dates.inspection.date')

    if (!grouped[dateString]){
      grouped[dateString] = {
        campaignInspections: [],
      }
    }

    // Add to Group
    grouped[dateString].campaignInspections.push(campaignInspection)

    return grouped
  }, {} as GroupedCampaignInspections)
)

export const mapCampaignInspectionToState = (campaignInspection: CampaignInspectionModel) => {
  const {
    campaign_id, dates, id, times, user_id,
  } = campaignInspection

  const inspectionDate = digObject(dates, 'inspection.date', '')
  const formattedInspectionDate = formatDate(inspectionDate, 'dd/MM/yyyy')

  const flattenedCampaignInspection = {
    campaign_id,
    end_time: digObject(times, 'inspection.end', ''),
    id,
    inspection_date: formattedInspectionDate,
    start_time: digObject(times, 'inspection.start', ''),
    user_id,
  }

  return flattenedCampaignInspection
}

export default mapCampaignInspectionToState
